import { JsonProperty } from "../../../models/utilities/json-property";
import { MetricBase } from "../shared/metric-base";

export class ProductionRun extends MetricBase {

    public id : number = 0;
    
    public name : string = '';
    
    public shipmentId : number|undefined = undefined;

    @JsonProperty({ toType: 'datetime-specific' })
    public departureTimeLocal : Date|undefined = undefined;
    
}
